import {
  CUSTOMER_TYPE,
  CUSTOMER_TYPE_ENTITY,
  NULL_STRING,
} from 'constants/constants';
import { Fade } from 'react-awesome-reveal';

const McoCustomerKPI = ({ customerDetails, selectedCustomer }) => {
  return (
    <div>
      <Fade cascade>
        <p className='title__bold title__base mb-0'>
          {customerDetails?.payerContributionToNational
            ? customerDetails?.payerContributionToNational + '%'
            : NULL_STRING}
        </p>
        <p className='title__bold sub-title__x-small mb-0'>
          {`Estimated ${CUSTOMER_TYPE.get(selectedCustomer?.flag) === CUSTOMER_TYPE_ENTITY.PARENTPAYER ? 'Parent' : ''} Payer Contribution % to Nation (across all BoB)
          (R12M)`}
        </p>
      </Fade>
    </div>
  );
};

export default McoCustomerKPI;
